import { Box, Tooltip } from "@mui/material";
import React from "react";

import { getAuditActorName } from "@/utils/auditActor";

interface AuditActorProps {
  value?: string | null;
  fallback?: React.ReactNode;
}

export const AuditActor: React.FC<AuditActorProps> = ({ value, fallback = null }) => {
  if (!value) return <>{fallback}</>;

  return (
    <Tooltip title={value}>
      <Box component="span" tabIndex={0}>
        {getAuditActorName(value)}
      </Box>
    </Tooltip>
  );
};
